module.exports = __webpack_public_path__ + "img/config-planner.c29bdd25.png";